// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".g-verify-code__btn{flex:0 0 auto;width:86px;height:40px;padding:0;margin-left:8px;font-size:14px;font-weight:600;border:none}", ""]);
// Exports
module.exports = exports;
